import { useEffect, FunctionComponent } from 'react';

interface TituloPaginaProps {
  title: string;
}

const TituloPagina: FunctionComponent<TituloPaginaProps> = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);

  return null;
};

export default TituloPagina;
